import DiferenciaDias from "./DiferenciaDias";

const time = {
    dd: DiferenciaDias
}

export default time;
